import React from "react";
import StickyHeaderContainer from "components/utility/sticky-header/StickyHeaderContainer";
import StickyHeader from "components/utility/sticky-header/StickyHeader";
import NoAuthNav from "./NoAuthNav";

const NoAuthNavXLink = (props) => {
	return (
		<StickyHeaderContainer>
			<StickyHeader>
				<NoAuthNav dataset={props.dataset} />
			</StickyHeader>
		</StickyHeaderContainer>
	);
};

export default NoAuthNavXLink;
